import React from "react";
import PropTypes from "prop-types";
import useComponentDidMount from "@hooks/UseComponentDidMount";

const Anchor = React.memo(({ id, onObjectLoad }) => {
  useComponentDidMount(() => {
    onObjectLoad(id);
  });
  return null;
});

Anchor.propTypes = {
  id: PropTypes.string.isRequired,
  onObjectLoad: PropTypes.func.isRequired,
};

export default Anchor;
